import React from 'react';
import { Outlet } from '@tanstack/react-router';

// Layout components
import { Sidebar } from './Sidebar';
import { Navbar } from './Navbar';
import { SettingsDrawer } from './SettingsDrawer';

// Layout component that contains the drawer structure
export const RootLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-base-100">
      {/* Main drawer layout with left sidebar and right settings */}
      <div className="drawer">
        {/* Invisible checkbox to control the left drawer */}
        <input id="nav-drawer" type="checkbox" className="drawer-toggle" />

        {/* Left sidebar drawer content */}
        <Sidebar />

        {/* Main content area (right drawer container) */}
        <div className="drawer-content">
          {/* Inner right-side drawer */}
          <div className="drawer drawer-end">
            {/* Invisible checkbox to control the right drawer */}
            <input id="settings-drawer" type="checkbox" className="drawer-toggle" />

            {/* Page content */}
            <div className="drawer-content">
              {/* Navbar */}
              <Navbar />

              {/* Main content */}
              <div className="p-4">
                {/* This is where the route components will render */}
                <Outlet />
              </div>
            </div>

            {/* Settings drawer */}
            <SettingsDrawer />
          </div>
        </div>
      </div>
    </div>
  );
};
